import {
  InnerLayout,
  ClientsHeader,
  ClientsContent,
  ClientsFilter,
  TabNavs,
} from "components";
import {useCallback, useState} from "react";
import {setSelectedClientTab, setSelectedTab} from "../store/actions";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../store";
//import Wrapper from "zyp-kiosk";

export default function Clients() {
  const [selectedView, setSelectedView] = useState("B2B clients");
  const dispatch = useDispatch();
  const {setSelectedTab} = useSelector<AppState, AppState["organizations"]>((state) => state.organizations);
  const setSelectedClientTabNav = useCallback(
      (key) => {
        dispatch(setSelectedClientTab(key));
      },
      [dispatch, setSelectedTab]
  );
  return (
    <InnerLayout>
      {{
        header: <ClientsHeader />,
        tabs: (
          <TabNavs
            selected={setSelectedTab}
            onChange={(value) => setSelectedClientTabNav(value)}
            options={[{ key: "B2B clients" }, { key: "B2C clients" }]}

          />
        ),
        content: <ClientsContent selectedView={setSelectedTab || "B2B clients"} />,
       filter: selectedView !== "enquiries" ? <ClientsFilter /> : null,
      }}
    </InnerLayout>
    //   <Wrapper></Wrapper>
  );
}
